export default __webpack_public_path__ + "static/media/saint-petersburg.9f79fbde.pdf";